import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import Spinner from 'Shared/components/Spinner';
import { getUserBySlug } from 'Shared/api/user';
import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import './SignupCheckEmail.scss';
import checkEmailUrl from './check_email_desktop.png';

function SignupCheckEmailDesktopOnly() {
  const [email, setEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { slug } = useParams();

  useEffect(() => {
    async function getShouldConfirmedEmail() {
      setIsLoading(true);
      try {
        const response = await getUserBySlug(slug);
        if (response && response.status === 200) setEmail(response.data.user.email);
        // eslint-disable-next-line no-empty
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
    }
    getShouldConfirmedEmail();
  }, []);

  const emailSentence = email ? `${email}` : '';
  return (
    <div className="signup-check-email d-flex flex-column w-100">
      <div className="signup-check-email-body d-flex align-items-center justify-content-center w-100 h-100">
        <div className="signup-check-email-content d-flex flex-column align-items-center justify-content-center w-100 pt-5 pb-4 px-4">
          {isLoading ? (
            <Spinner activeIf />
          ) : (
            <>
              <CharmaLogo type="icon" width="55" className="mb-3" />
              <div className="signup-check-email-title text-center mb-3">Almost there!</div>
              <div className="signup-check-email-section text-break text-center">
                PI Perform is best experienced on desktop. We&#39;ve sent a link to <b>{emailSentence}</b>. Check your
                email on a laptop or desktop to complete your registration.
              </div>
              <div className="d-flex py-2 mb-4 mt-3">
                <img src={checkEmailUrl} alt={checkEmailUrl} width="142" />
              </div>
              <div className="signup-check-email-section text-center mb-4">Be sure to check any spam folders.</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SignupCheckEmailDesktopOnly;
